var u = /* @__PURE__ */ ((e) => (e.BOOLEAN = "BOOLEAN", e.INTEGER = "INTEGER", e.DOUBLE = "DOUBLE", e.STRING = "STRING", e.JSON = "JSON", e))(u || {}), S = /* @__PURE__ */ ((e) => (e.UNKNOWN = "UNKNOWN", e.SUCCESS = "SUCCESS", e.SDK_ERROR = "SDK_ERROR", e.INVALID_REQUEST = "INVALID_REQUEST", e.NOT_FOUND = "NOT_FOUND", e.WRONG_TYPE = "WRONG_TYPE", e.SERVICE_NOT_READY = "SERVICE_NOT_READY", e))(S || {}), F = /* @__PURE__ */ ((e) => (e.UNIT = "UNIT", e.MERCHANT = "MERCHANT", e.DEVICE_ID = "DEVICE_ID", e.ANONYMOUS_VISITOR = "ANONYMOUS_VISITOR", e.PERSON = "PERSON", e))(F || {}), y = /* @__PURE__ */ ((e) => (e.NOT_SUPPLIED = "NOT_SUPPLIED", e.PIE = "PIE", e.CAPITAL = "CAPITAL", e.SQUARE_CONSOLE = "SQUARE_CONSOLE", e.TIDAL = "TIDAL", e.SHOP = "SHOP", e))(y || {}), U = /* @__PURE__ */ ((e) => (e.UNKNOWN = "unknown", e.SQUARE = "square", e.REGISTER = "register", e.DASHBOARD = "dashboard", e.RETAIL = "retail", e.RESTAURANT = "restaurant", e.INVOICES = "invoices", e.APPOINTMENTS = "appointments", e.READERSDK = "readersdk", e.KDS = "kds", e.SIGNIN = "signin", e.SINGLE_BINARY = "single_binary", e.TERMINALAPI = "terminalapi", e.WEEBLY = "weebly", e.TERMINAL = "terminal", e.TERMINAL_API = "terminal_api", e.KDS_EXPO = "kds_expo", e.PAYROLL = "payroll", e.CARDCASE = "cardcase", e.RESTAURANT_MOBILE = "restaurant_mobile", e.BALANCE = "balance", e.FNBKIOSK = "fnbkiosk", e.GO = "go", e))(U || {});
const b = "application/json", k = "application/json", B = "https://squareupsandbox.com", G = "/1.0/features/get-flags", M = "/1.0/features/get-flags-sandbox", w = y.PIE;
function K(e = "") {
  const t = e.endsWith("/") ? e.slice(0, -1) : e, n = e.includes(B) ? M : G;
  return `${t}${n}`;
}
/*! js-cookie v3.0.5 | MIT */
function v(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var i in n)
      e[i] = n[i];
  }
  return e;
}
var V = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function A(e, t) {
  function n(a, c, r) {
    if (!(typeof document > "u")) {
      r = v({}, t, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var f in r)
        r[f] && (s += "; " + f, r[f] !== !0 && (s += "=" + r[f].split(";")[0]));
      return document.cookie = a + "=" + e.write(c, a) + s;
    }
  }
  function i(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var c = document.cookie ? document.cookie.split("; ") : [], r = {}, s = 0; s < c.length; s++) {
        var f = c[s].split("="), E = f.slice(1).join("=");
        try {
          var g = decodeURIComponent(f[0]);
          if (r[g] = e.read(E, g), a === g)
            break;
        } catch {
        }
      }
      return a ? r[a] : r;
    }
  }
  return Object.create(
    {
      set: n,
      get: i,
      remove: function(a, c) {
        n(
          a,
          "",
          v({}, c, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return A(this.converter, v({}, this.attributes, a));
      },
      withConverter: function(a) {
        return A(v({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var q = A(V, { path: "/" });
async function Y({
  flagRequests: e,
  userToken: t,
  origin: n,
  headers: i,
  withCredentials: a,
  project: c = w,
  userAttributes: r
}) {
  const s = {
    project: c,
    flag_requests: e,
    user_token: t,
    user_attributes: {
      user_attributes: J(r)
    }
  }, f = K(n), E = await fetch(f, {
    method: "POST",
    headers: {
      Accept: b,
      "Content-Type": k,
      ...x(),
      ...i
    },
    body: JSON.stringify(s),
    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#including_credentials
    credentials: a ? "include" : "same-origin"
  });
  if (!E.ok)
    throw new Error(`Request failed with status code ${E.status}`);
  const g = await E.json();
  if (g.status !== S.SUCCESS)
    throw new Error(
      `Request to retrieve feature flags failed with status ${g.status}`
    );
  return g.flag_responses ?? [];
}
function x() {
  const e = q.get("_js_csrf");
  return e !== void 0 ? { "x-csrf-token": e } : null;
}
function J(e = []) {
  const t = [...e];
  return e.some((n) => n.name === "platform") || t.push({ name: "platform", string_value: "web" }), t;
}
function H(e) {
  return e.flag_type === u.BOOLEAN && typeof e.flag_name == "string";
}
function W(e) {
  return e.flag_type === u.DOUBLE && typeof e.flag_name == "string";
}
function j(e) {
  return e.flag_type === u.INTEGER && typeof e.flag_name == "string";
}
function P(e) {
  return e.flag_type === u.JSON && typeof e.flag_name == "string";
}
function $(e) {
  return e.flag_type === u.STRING && typeof e.flag_name == "string";
}
function m(e, t) {
  if (e.status === S.SUCCESS) {
    if (H(e))
      return e.bool_value;
    if (j(e))
      return e.int_value;
    if (W(e))
      return e.double_value;
    if ($(e))
      return e.string_value;
    if (P(e)) {
      if (!e.string_value)
        return;
      try {
        return JSON.parse(e.string_value);
      } catch {
        typeof t == "function" && t({
          flagKey: e.flag_name,
          stringifiedValue: e.string_value
        });
        return;
      }
    }
  }
}
function Q(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of Object.values(e)) {
    const i = {
      value: void 0,
      config: n
    };
    t.set(n.key, i);
  }
  return t;
}
function X(e) {
  const { key: t, flagType: n } = e;
  return {
    flag_name: t,
    flag_type: n
  };
}
function z({
  flagConfig: e,
  flagResponse: t,
  onIncorrectFlagType: n,
  onMalformedJsonFlagValue: i
}) {
  return t.status === S.WRONG_TYPE ? (typeof n == "function" && n({
    flagKey: e.key,
    expectedType: e.flagType
  }), e.defaultValue) : m(t, i);
}
function T(e, t) {
  if (typeof t == "function")
    for (const [n, { config: i, value: a }] of e)
      a === void 0 && t({
        flagKey: n,
        flagType: i.flagType
      });
}
function ee({
  project: e = w,
  flagConfigs: t,
  origin: n,
  headers: i,
  withCredentials: a,
  userAttributes: c,
  userToken: r,
  offlineMode: s,
  onIncorrectFlagType: f,
  onMalformedJsonFlagValue: E,
  onMissingFlagValue: g,
  onUnexpectedFlagValue: _
}) {
  const p = Q(t);
  let h = !1, I = !1;
  function C(l) {
    var d;
    if (h = !0, I)
      throw new Error(
        "Bootstrapping flags after `loadFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required."
      );
    for (const o in l) {
      const R = ((d = t[o]) == null ? void 0 : d.key) ?? "", O = p.get(R);
      if (O === void 0) {
        typeof _ == "function" && _({
          flagKey: o,
          value: l[o]
        });
        continue;
      }
      p.set(R, {
        config: O.config,
        value: l[o]
      });
    }
    T(p, g);
  }
  async function D() {
    if (I = !0, h)
      throw new Error(
        "Loading flags after `boostrapFlags` has been invoked is not supported. Instantiate a different client instance if both bootstrapped and client-loaded feature flags are required."
      );
    if (r === void 0)
      throw new TypeError(
        "Clients require a `userToken` to retrieve flags from the Feature Relay service via `loadFlags`. Be sure to invoke `createFeatureRelayClient` with a valid `userToken` instance."
      );
    if (s)
      return;
    const l = Object.values(t).map(X), d = await Y({
      project: e,
      flagRequests: l,
      origin: n,
      headers: i,
      withCredentials: a,
      userAttributes: c,
      userToken: r
    });
    for (const o of d) {
      const R = p.get(o.flag_name);
      if (!R) {
        typeof _ == "function" && _({
          dataType: o.flag_type,
          flagKey: o.flag_name,
          value: m(o)
        });
        continue;
      }
      const O = z({
        flagConfig: R.config,
        flagResponse: o,
        onIncorrectFlagType: f,
        onMalformedJsonFlagValue: E
      });
      p.set(R.config.key, { ...R, value: O });
    }
    T(p, g);
  }
  function L(l) {
    const d = p.get(l.key);
    if (!d)
      throw new Error(
        `Attempted to read a flag (${l.key}) that has not been configured. Make sure you're using the correct client instance, or that you've included this flag when instantiating the client.`
      );
    if (!h && !I)
      throw new Error(
        "You have not yet fetched values for your flags. Retrieve flag values with the `loadFlags` method, or bootstrap values with the `bootstrapFlags` method."
      );
    const o = l.getMock();
    return o.isSet ? o.value : s ? l.defaultValue : d.value ?? l.defaultValue;
  }
  return {
    bootstrapFlags: C,
    getFlagValue: L,
    loadFlags: D
  };
}
function Z(e) {
  let t = { isSet: !1, value: void 0 };
  return {
    ...e,
    getMock() {
      return t;
    },
    setMockValue(n) {
      if (t.isSet) {
        const i = "A mock value has been re-set with out being cleared. This may be an indication of state leaking between tests. Clear mock values with `.clearMockValue()` before re-setting.";
        throw new Error(i);
      }
      t = { value: n, isSet: !0 };
    },
    clearMockValue() {
      t = { value: void 0, isSet: !1 };
    }
  };
}
function N({
  key: e,
  defaultValue: t,
  flagType: n
}) {
  if (e.length === 0)
    throw new Error(
      "Feature flag configuration instances require non-empty key"
    );
  return Z({
    key: e,
    defaultValue: t,
    flagType: n
  });
}
function te({
  key: e,
  defaultValue: t
}) {
  return N({
    key: e,
    defaultValue: t,
    flagType: u.BOOLEAN
  });
}
function ne({
  key: e,
  defaultValue: t
}) {
  if (!Number.isInteger(t))
    throw new TypeError(
      `You supplied a non-integer default value to the ${e} flag.To create a flag with support for decimal values, use createDoubleFlag.`
    );
  return N({
    key: e,
    defaultValue: t,
    flagType: u.INTEGER
  });
}
function ae({
  key: e,
  defaultValue: t
}) {
  return N({
    key: e,
    defaultValue: t,
    flagType: u.DOUBLE
  });
}
function re({
  key: e,
  defaultValue: t
}) {
  return N({
    key: e,
    defaultValue: t,
    flagType: u.STRING
  });
}
function ie({
  key: e,
  defaultValue: t
}) {
  return N({
    key: e,
    defaultValue: t,
    flagType: u.JSON
  });
}
export {
  u as DataType,
  U as Product,
  y as Project,
  S as Status,
  F as TokenType,
  te as createBooleanFlag,
  ae as createDoubleFlag,
  ee as createFeatureRelayClient,
  ne as createIntegerFlag,
  ie as createJSONFlag,
  re as createStringFlag,
  Y as getFlags,
  m as readFlagValueFromResponse
};
